import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import {BrowserRouter as Router} from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as CustomThemeProvider } from './context/ThemeContext'
import theme from './context/theme'
import ErrorBoundaryFallback from './components/common/ErrorBoundaryFallback'
import './i18n'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2, // 20% de transacciones de rendimiento
  replaysSessionSampleRate: 0.1, // 10% de sesiones normales
  replaysOnErrorSampleRate: 1.0, // 100% de grabacion cuando ocurre un error
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={({ error, resetError, eventId }) => (
    <ErrorBoundaryFallback error={error} resetError={resetError} eventId={eventId} />
  )}>
    <Router>
      <AuthProvider>
        <CustomThemeProvider>
          <MuiThemeProvider theme={theme}>
            <React.StrictMode>
              <App />
            </React.StrictMode>
          </MuiThemeProvider>
        </CustomThemeProvider>
      </AuthProvider>
    </Router>
  </Sentry.ErrorBoundary>
)